import React from "react";

import AdminProductoRow from "./AdminProductoRow";

function AdminInventario({
  filtroTurno,
  setFiltroTurno,
  filtroSeccion,
  setFiltroSeccion,
  seccionesDelTurnoSeleccionado,
  productosFiltradosEnInventario,
  handleSeleccionarEditar,
  handleCambiarDisponibilidad,
  handleEliminarProducto,
}) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "16px",
        border: "1px solid #e2e2e2",
      }}
    >
      <h3
        style={{
          margin: "0 0 15px 0",
          fontSize: "18px",
          fontWeight: "700",
        }}
      >
        📋 Inventario
      </h3>

      <div
        style={{
          marginBottom: "16px",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "13px",
            fontWeight: "700",
            marginBottom: "6px",
            color: "#444",
          }}
        >
          Turno:
        </label>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <button
            type="button"
            onClick={() => {
              setFiltroTurno("matutino");
              setFiltroSeccion("TODAS");
            }}
          >
            🌅 Matutino
          </button>

          <button
            type="button"
            onClick={() => {
              setFiltroTurno("vespertino");
              setFiltroSeccion("TODAS");
            }}
          >
            🌌 Vespertino
          </button>

          <button
            type="button"
            onClick={() => {
              setFiltroTurno("todo");
              setFiltroSeccion("TODAS");
            }}
          >
            🚀 Todo
          </button>
        </div>
      </div>

      <div
        style={{
          marginBottom: "20px",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "13px",
            fontWeight: "700",
            marginBottom: "6px",
            color: "#444",
          }}
        >
          Sección:
        </label>

        <select
          value={filtroSeccion}
          onChange={(e) => setFiltroSeccion(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          <option value="TODAS">TODAS</option>

          {seccionesDelTurnoSeleccionado.map((cat, idx) => (
            <option key={idx} value={cat}>
              📁 {cat}
            </option>
          ))}
        </select>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {productosFiltradosEnInventario.length === 0 ? (
          <div
            style={{
              backgroundColor: "#fafafa",
              border: "1px dashed #ddd",
              borderRadius: "12px",
              padding: "16px",
              fontSize: "14px",
              color: "#666",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            No hay productos en este filtro.
          </div>
        ) : (
          productosFiltradosEnInventario.map((prod) => (
            <AdminProductoRow
              key={prod.id}
              prod={prod}
              handleSeleccionarEditar={handleSeleccionarEditar}
              handleCambiarDisponibilidad={handleCambiarDisponibilidad}
              handleEliminarProducto={handleEliminarProducto}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default AdminInventario;
